export class StatoFinanziamento{
    id:number;
    statoFinanziamento:string;
}